<div style="height: calc(100vh - 310px);" *ngIf="dataSource$ | async as dataSource">
  <div style="overflow: auto; height: calc(100vh - 373px); padding: 0 35px;">
    <div style="overflow: visible;" *ngIf="dataSource.data.length > 0">
      <div
        style="display: flex; justify-content: end; gap: 10px;">
        <button *inRole="[roles.Administrator, roles.Developer, roles.OperationsExpertFeatureSet]" (click)="retry()"
                class="action-button" mat-button aria-label="Clear"
                [disabled]="selectedIds.length < 1"
                style="transition: 350ms ease-in-out; background: #3949AB; color: #FFF; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);">
          <span class="fal fa-refresh"></span>
          <span style="padding-left: 10px;">Retry</span>
        </button>
        <button *inRole="[roles.Administrator, roles.Developer, roles.OperationsExpertFeatureSet]" [disabled]="isFunctionAllowedToFail()" (click)="fail()"
                class="action-button" mat-button aria-label="Clear" [disabled]="selectedIds.length < 1"
                style="transition: 350ms ease-in-out; background: #FF4343; color: #FFF; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);">
          <span class="fal fa-ban"></span>
          <span style="padding-left: 10px;">Fail</span>
        </button>
        <button (click)="refresh()" class="action-button" mat-button aria-label="Clear"
                style="transition: 350ms ease-in-out; background: #1e6500; color: #FFF; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);">
          <span class="fal fa-repeat"></span>
          <span style="padding-left: 10px;">Refresh</span>
        </button>
      </div>
      <table mat-table [dataSource]="dataSource" class="table-width"
             [trackBy]="trackByFn" style="width: 100%; border-spacing: 0 3px; background: transparent;">
        <ng-container matColumnDef="selecto-checko">
          <th mat-header-cell *matHeaderCellDef style="width: 5%">
            <div class="form-control-wrapper">
              <mat-checkbox
                [indeterminate]="selectedIds.length > 0 && selectedIds.length < dataSource.data.length"
                [checked]="selectedIds.length === dataSource.data.length"
                (change)="selectAll($event.checked)"></mat-checkbox>
            </div>
          </th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async">
            <div class="form-control-wrapper">
              <mat-checkbox (click)="$event.stopPropagation()" (change)="toggleSelected(element)"
                            [ngModel]="isSelected(element)"></mat-checkbox>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="caseName">
          <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 14px">Case</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.caseName}}</td>
        </ng-container>
        <ng-container matColumnDef="functionName">
          <th mat-header-cell *matHeaderCellDef style="width: 5%; font-size: 14px">Step</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.functionName}}</td>
        </ng-container>
        <ng-container matColumnDef="duration">
          <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 14px">Started</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.createdDateTime | date:'medium'}}
            ({{calculateDuration(element.createdDateTime)}})
          </td>
        </ng-container>
        <ng-container matColumnDef="documentId">
          <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 14px">Document Id</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.documentId }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr [@rowTransitionAnimation]="{ value: '', params: { delay: i * 100 } }" mat-row *matRowDef="let row; let i = index; columns:columnsToDisplay"
            [routerLink]="['/','platform','activity','snapshot', row.stepId]" style="cursor: pointer;" [style.height.px]="rowHeight$ | async">
        </tr>
      </table>
    </div>

    <div *ngIf="dataSource.data.length < 1">
      <div
        style="display: flex; justify-content: center; align-items: center; width: 100%; height: 450px; font-size: 20px;">
        <span class="fal fa-microchip"></span>
        <span style="padding-left: 10px;">No Long-Running Processing Steps.</span>
      </div>
    </div>
  </div>
  <div class="paging-container" style="padding: 0 35px;">
    <mat-paginator [pageSize]="take$ | async" [pageSizeOptions]="[25, 50, 100, 200]"
                   [length]="total" (page)="movePage($event)" showFirstLastButtons
                   #paginator>
    </mat-paginator>
  </div>
</div>

